import React, { Component } from 'react';
import styled from 'styled-components';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';

import Media from 'css/Media';

class Quote extends Component {

    render() {
        const { data } = this.props;

        return (
            <ModuleWrapper>
                <Container grid>
                    <GridElement
                        colStart={{default: 1, s: 7}}
                        colEnd={{default: 8, s: 18}}
                    >
                        <h3>— {data.quote}</h3>
                        <p>{data.credentials}</p>
                    </GridElement>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default Quote;

const ModuleWrapper = styled.article`
    margin: ${props => props.theme.spacing.contentL} 0 ${props => props.theme.spacing.elementXS};
    
    ${Media.greaterThan('s')`
        margin: ${props => props.theme.spacing.elementS} 0;
    `}

    .container {
        p {
            font-size: 14px;
            line-height: 23px;

            ${Media.lessThan('s')`
                line-height: 20px;
            `}
        }

        h3 {
            padding-bottom: ${props => props.theme.spacing.contentM};

            ${Media.greaterThan('s')`
                padding-bottom: ${props => props.theme.spacing.contentL};
            `}
        }
    }
`